var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIconArrowXCloseSmall = function SvgIconArrowXCloseSmall(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70203 7.01857L12.9478 11.2644C13.4195 11.7361 13.4195 12.5009 12.9478 12.9726V12.9726C12.4761 13.4443 11.7113 13.4443 11.2396 12.9726L6.99381 8.72679L2.5809 13.1397C2.10577 13.6148 1.33543 13.6148 0.860301 13.1397V13.1397C0.38517 12.6646 0.38517 11.8942 0.8603 11.4191L5.27321 7.00619L1.05217 2.78515C0.580453 2.31343 0.580454 1.54864 1.05217 1.07692V1.07692C1.52388 0.60521 2.28868 0.60521 2.76039 1.07692L6.98143 5.29797L11.4191 0.8603C11.8942 0.385169 12.6646 0.38517 13.1397 0.860301V0.860301C13.6148 1.33543 13.6148 2.10577 13.1397 2.5809L8.70203 7.01857Z",
    fill: "#1C1C1E",
    fillOpacity: 0.16
  })));
};
export default SvgIconArrowXCloseSmall;